import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import { View, TouchableOpacity, TouchableWithoutFeedback } from "react-native";
import Text from "app/components/Text";

import Hoverable from "app/components/Hoverable";

import { StyleContext } from "app/contexts/Style";

export default class ButtonGroup extends React.Component {
  static contextType = StyleContext;

  render() {
    let { options, selected, onSelect, small } = this.props;

    return (
      <View style={this.styles().buttonGroup}>
        {options.map((option, i) => {
          return (
            <Text
              key={i}
              button
              selectedButton={selected == option.value}
              smallButton={small}
              style={[this.styles().groupedButton]}
              onPress={() => onSelect(option.value)}
            >
              {option.text}
            </Text>
          );
        })}
      </View>
    );
  }

  styles = () => ({
    buttonGroup: {
      flexDirection: "row",
      borderRadius: this.context.sizes.smallBorderRadius,
      overflow: "hidden",
      marginRight: this.context.sizes.base,
    },
    groupedButton: {
      borderRadius: 0,
      marginRight: 0,
    },
  });
}
